<template>
  <div class="space-y-24">
    <div class="text-static-default-mid body-1 flex md:justify-center">
      {{ i18n(translations.pageDescription) }}
    </div>

    <div v-if="!isEmpty(eligibleInsurances)" class="space-y-24">
      <h3 class="text-static-default-hi heading-3">
        {{ i18n(translations.eligibleDevices) }}
      </h3>

      <EligibleInsuranceCard
        v-for="eligibleInsurance in eligibleInsurances"
        :key="eligibleInsurance.orderlineId"
        :eligible-insurance
      />

      <h3 class="text-static-default-hi heading-3">
        {{ i18n(translations.yourProtectionPlans) }}
      </h3>
    </div>

    <div class="space-y-24">
      <PolicyCard v-for="policy in policies" :key="policy.policyId" :policy />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import EligibleInsuranceCard from '../../components/EligibleInsuranceCard/EligibleInsuranceCard.vue'
import type { EligibleInsurance, Policy } from '../../types'

import translations from './PoliciesAndEligibleInsurances.translations'
import PolicyCard from './components/PolicyCard/PolicyCard.vue'

defineProps<{
  policies: Policy[]
  eligibleInsurances: EligibleInsurance[]
}>()

const i18n = useI18n()
</script>
